import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Box, Grid, Paper, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import defaultUser from "../../../../../../assets/user.png";
import ImageLoader from "react-load-image";
import Preloader from "../../../../../../utilities/components/Preloader/Preloader";
import { APP_URLS } from "../../../../../../utilities/constants";
import LockIcon from "@material-ui/icons/Lock";
import MessageDialog from "../../../../../../utilities/components/MessageDialog/MessageDialog";
import { getUserInfo } from "../../../../../../utilities/storage";
/**
 * function to render case item
 * @param caseItem: case item details
 * @returns {JSX.Element}
 * @constructor
 */
const CaseItem = ({ caseItem, doctorId }) => {
  const [open, setOpen] = useState(false);

  const hasAccess = caseItem.Caregivers?.some(
    (doctor) => doctor.id === doctorId
  );
  const formatToIST = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata", // Converts to IST
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleCaseClick = (e) => {
    if (!hasAccess) {
      e.preventDefault();
      setOpen(true);
    }
  };

  const classes = useStyles();
  return (
    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
      <Box component={Paper} className={classes.contentContainer}>
        <Box
          component={Link}
          to={`${APP_URLS.CASES}/${caseItem.id}`}
          className={classes.contentCardUpper}
          onClick={handleCaseClick}
        >
          <Box
            className={classes.careHeader}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box className={classes.headerLabel}>
              {caseItem.jerseyNum ? `Jersey no: ${caseItem.jerseyNum}` : ""}
            </Box>

            <Box display="flex" alignItems="center">
              <Box className={classes.headerLabel}>Case no: {caseItem.id}</Box>
              {!hasAccess && (
                <LockIcon
                  className={classes.lockIcon}
                  style={{ marginLeft: 4 }}
                />
              )}
            </Box>
          </Box>

          <Box className={classes.contentCard}>
            <Box className={classes.profileOuterContainer}>
              <Box className={classes.profileContainer}>
                <Box className={classes.profileInnerContainer}>
                  <ImageLoader
                    src={caseItem.imageUrl ? caseItem.imageUrl : defaultUser}
                  >
                    <img
                      alt={caseItem.id}
                      className={`${classes.profileImage} ${
                        caseItem.priority === 1 ? classes.critical : ""
                      }`}
                    />
                    <div
                      className={`${classes.profileImageError} ${
                        caseItem.priority === 1 ? classes.critical : ""
                      }`}
                    >
                      {caseItem.id}
                    </div>
                    <Preloader
                      alt={caseItem.id}
                      className={`${classes.profileImage} ${
                        caseItem.priority === 1 ? classes.critical : ""
                      }`}
                    />
                  </ImageLoader>
                </Box>
              </Box>
            </Box>

            <Box className={classes.infoContainer}>
              <Typography
                classes={{
                  root: `${classes.name} ${
                    caseItem.priority === 1 ? classes.nameCritical : ""
                  }`,
                }}
              >
                {caseItem.externalReport?.attributes?.name ??
                  `${caseItem.firstName} ${caseItem.lastName}`}
              </Typography>
              <Typography noWrap classes={{ root: classes.description }}>
                {caseItem.desc}
              </Typography>
              <Box className={classes.createdContainer}>
                <Box className={classes.createdUserContainer}>
                  <Typography classes={{ root: classes.createdBy }}>
                    {`${caseItem.updatedByFirstName} ${caseItem.updatedByLastName}`}
                    , updated : {formatToIST(caseItem.updatedAt)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <MessageDialog
        open={open}
        setOpen={setOpen}
        title="Sorry!"
        message="You do not have permission to view this case. Contact a case doctor to request permission."
      />
    </Grid>
  );
};

export default CaseItem;
